export default __webpack_public_path__ + "static/media/person.9792209e.svg";